/**
 * 延时
 * @param time
 */
export function delayedPromise(time: number): Promise<void> {
    return new Promise<void>((resolve) => {
        setTimeout(() => {
            resolve();
        }, time);
    });
}
